import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PromisePool } from 'es6-promise-pool';
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIdeleteCollectionGroup,
  APIupdateCollection,
  APIdeleteCollections,
} from '../../../api/Collections';

import { addFlashMessage } from '../../../helpers/FlashMessages';

import ErrorBoundary from '../../ErrorBoundary';

class CollectionGroupDeleteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: null,
      targetCollectionGroup: null,
      view: null,
      deleting: false,
      updatedItems: 0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.resetView = this.resetView.bind(this);
  }

  getCollectionsPromisePool(mode) {
    const { collectionGroup } = this.props;
    const { targetCollectionGroup } = this.state;

    let counterCollections = 0;
    const promiseProducerCollections = () => {
      if (counterCollections < collectionGroup.collections.length) {
        const collection = collectionGroup.collections[counterCollections];
        counterCollections += 1;
        if (mode === 'move') {
          collection.group_id = targetCollectionGroup;
          return APIupdateCollection({ collection }).then(() => {
            this.setState({ updatedItems: counterCollections });
          });
        }
        if (mode === 'delete') {
          return APIdeleteCollections({
            collectionUuidList: [collection.uuid],
          }).then(() => {
            this.setState({ updatedItems: counterCollections });
          });
        }
      }
      return null;
    };

    return new PromisePool(promiseProducerCollections, 2);
  }

  handleDelete() {
    const {
      intl,
      collectionGroup,
      handleClose,
      afterDeleteCollectionGroup,
    } = this.props;
    const { mode } = this.state;

    this.setState({ deleting: true });

    this.getCollectionsPromisePool(mode).start().then(() => {
      APIdeleteCollectionGroup(collectionGroup.id).then(() => {
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'Collection group has been deleted' }),
        });
        afterDeleteCollectionGroup();
        handleClose();
      });
    });
  }

  handleChange(e) {
    const {
      name,
      value,
    } = e.target;
    const { state } = this;

    if (name === 'mode' || name === 'targetCollectionGroup') {
      state[name] = value;
      this.setState(state);
    }
  }

  resetView(e) {
    e.preventDefault();
    this.setState({ view: null });
  }

  deleteButtonText() {
    const {
      intl,
      collectionGroup,
    } = this.props;
    const {
      mode,
      deleting,
      updatedItems,
    } = this.state;
    const collections = collectionGroup.collections.length;

    if (deleting) {
      if (mode === 'move') {
        return intl.formatMessage(
          { defaultMessage: 'Moved {updatedItems} of {collections} Collections...' },
          { updatedItems, collections },
        );
      }
      if (mode === 'delete') {
        if (collections > 0) {
          return intl.formatMessage(
            { defaultMessage: 'Deleted {updatedItems} of {collections} Collections...' },
            { updatedItems, collections },
          );
        }
      }
      return intl.formatMessage({ defaultMessage: 'Deleting...' });
    }

    return intl.formatMessage({ defaultMessage: 'Delete' });
  }

  render() {
    const {
      mode,
      view,
      deleting,
    } = this.state;
    const {
      intl,
      collectionGroup,
      collectionGroups,
      handleClose,
    } = this.props;

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose} className="modal-header-center">
          {intl.formatMessage({ defaultMessage: 'Delete collection group' })}
        </ModalHeader>

        {!view && (
          <ModalBody>
            <p>
              {intl.formatMessage(
                { defaultMessage: 'You are about to delete <strong>{name}</strong> collection group. This operation can not be undone!' },
                {
                  name: collectionGroup.name,
                  strong: name => <strong>{name}</strong>,
                },
              )}
            </p>
            {collectionGroup.collections.length > 0 && (
              <Fragment>
                <p>
                  {intl.formatMessage(
                    { defaultMessage: 'This collection group contains {count} Collections. What would you like to do with them?' },
                    { count: collectionGroup.collections.length },
                  )}
                </p>
                <Form className="delete-collection-group-form">
                  <FormGroup check>
                    <Label className="delete-collection-group-item" check>
                      <Input
                        type="radio"
                        name="mode"
                        value="move"
                        onChange={this.handleChange}
                      />
                      {' '}
                      <h5 className="delete-collection-group-title">
                        {intl.formatMessage({ defaultMessage: 'Move Collections' })}
                      </h5>
                      <p className="delete-collection-group-details">
                        {intl.formatMessage({ defaultMessage: 'All Collections will be moved to the selected collection group.' })}
                      </p>
                    </Label>
                  </FormGroup>
                  {mode === 'move' && (
                    <div className="delete-collection-group-move">
                      <FormGroup className="delete-collection-group-move-form">
                        <Label>
                          <Input
                            type="select"
                            name="targetCollectionGroup"
                            onChange={this.handleChange}
                          >
                            {collectionGroups
                              .filter(cg => (cg.id !== collectionGroup.id))
                              .map(cg => (
                                <option key={cg.id} value={cg.id}>
                                  {cg.name}
                                </option>
                              ))}
                          </Input>
                        </Label>
                      </FormGroup>
                    </div>
                  )}
                  <FormGroup check>
                    <Label className="delete-collection-group-item" check>
                      <Input
                        type="radio"
                        name="mode"
                        value="delete"
                        onChange={this.handleChange}
                      />
                      {' '}
                      <h5 className="delete-collection-group-title">
                        {intl.formatMessage({ defaultMessage: 'Delete Collections' })}
                      </h5>
                      <p className="delete-collection-group-details">
                        {intl.formatMessage({ defaultMessage: 'All Collections will be permanently removed. Doing this will not delete the files within the Collections.' })}
                      </p>
                    </Label>
                  </FormGroup>
                </Form>
              </Fragment>
            )}
          </ModalBody>
        )}

        {(view === 'error' && !deleting) && (
          <ModalBody className="modal-msg-body modal-msg-error">
            <Container>
              <Row>
                <Col>
                  {intl.formatMessage({ defaultMessage: 'Something went wrong. Please try again or contact us.' })}
                </Col>
              </Row>
            </Container>
          </ModalBody>
        )}

        {!view && (
          <ModalFooter className="justify-r">
            <div className="buttons-group">
              <Button
                color="secondary"
                onClick={handleClose}
                disabled={deleting}
              >
                {intl.formatMessage({ defaultMessage: 'Cancel' })}
              </Button>
              {' '}
              <Button
                color="primary"
                onClick={this.handleDelete}
                disabled={deleting || (!mode && collectionGroup.collections.length > 0)}
              >
                {this.deleteButtonText()}
              </Button>
            </div>
          </ModalFooter>
        )}

        {(view === 'error' && !deleting) && (
          <ModalFooter className="justify-l">
            <div className="buttons-group">
              <Button color="link" onClick={this.resetView}>
                <i className="far fa-long-arrow-left" />
                {intl.formatMessage({ defaultMessage: 'Back' })}
              </Button>
            </div>
          </ModalFooter>
        )}
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  collectionGroups: state.Collections.collectionGroups,
});

CollectionGroupDeleteModal.propTypes = {
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  collectionGroup: PropTypes.object.isRequired,
  collectionGroups: PropTypes.array.isRequired,
  afterDeleteCollectionGroup: PropTypes.func,
};

CollectionGroupDeleteModal.defaultProps = {
  afterDeleteCollectionGroup: () => {},
};

export default connect(mapStateToProps)(injectIntl(CollectionGroupDeleteModal));
